<template>
  <l-container class="mt-4">    
    <apexchart
      width="100%"
      height="300"
      :options="options"
      :series="[]"
    ></apexchart>
  </l-container>
</template>


<script>
import * as moment from "moment";
import ApexchartValidate from "./apexchartvalidate";
import VueApexCharts from "vue-apexcharts";
import ApexCharts from "apexcharts";

export default {
  name: "LLChartValidate",
  components: {
    apexchart: VueApexCharts
  },
  data() {
    return {
      hasData: false,
      options: ApexchartValidate.settings(),
    };
  },
  methods: {
    removeSeries() {      
      
    },
    addSeries(series) {  
      ApexCharts.exec("apexchart", "updateSeries", series, false); // Avoid slow vue observable object  
      ApexCharts.exec("apexchart", "toggleSeries", "observationid");
    }
  }
};
</script>
